// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup--3bOFs","statusList":"statusList--qT82I"};